<mat-card class="users-card trinta-card mb-25 bg-white border-none d-block">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mt-0 mb-5">Users</h5>
      <p class="subtitle">
        Find a username to use when sharing a session.
      </p>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="directory-toolbar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search usernames</mat-label>
        <input
          matInput
          type="search"
          [(ngModel)]="searchTerm"
          (ngModelChange)="applyFilter()"
          autocomplete="off"
          aria-label="Search usernames"
        >
      </mat-form-field>

      <span class="user-count" *ngIf="!isLoading && !errorMessage">
        {{ filteredUsers.length }}
        {{ filteredUsers.length === 1 ? 'user' : 'users' }}
      </span>
    </div>

    <div class="state-message" *ngIf="isLoading">
      <mat-spinner diameter="38"></mat-spinner>
      <span>Loading users…</span>
    </div>

    <div class="state-message error-state" *ngIf="!isLoading && errorMessage">
      <i-feather name="alert-circle" aria-hidden="true"></i-feather>
      <span>{{ errorMessage }}</span>
      <button mat-stroked-button type="button" (click)="loadUsers()">
        <i-feather name="refresh-cw" aria-hidden="true"></i-feather>
        Try again
      </button>
    </div>

    <div
      class="state-message"
      *ngIf="!isLoading && !errorMessage && filteredUsers.length === 0"
    >
      <i-feather name="user-x" aria-hidden="true"></i-feather>
      <span>
        {{ searchTerm.trim() ? 'No usernames match your search.' : 'No users are available.' }}
      </span>
    </div>

    <div
      class="users-grid"
      *ngIf="!isLoading && !errorMessage && filteredUsers.length > 0"
    >
      <article
        class="user-row"
        *ngFor="let user of filteredUsers; trackBy: trackByUsername"
      >
        <div class="user-identity">
          <span class="user-avatar" aria-hidden="true">
            {{ usernameInitial(user.username) }}
          </span>
          <span class="username">{{ user.username }}</span>
        </div>

        <button
          mat-stroked-button
          type="button"
          class="copy-button"
          (click)="copyUsername(user.username)"
          [matTooltip]="'Copy ' + user.username"
          [attr.aria-label]="'Copy username ' + user.username"
        >
          <i-feather
            [name]="copiedUsername === user.username ? 'check' : 'copy'"
            aria-hidden="true"
          ></i-feather>
          {{ copiedUsername === user.username ? 'Copied' : 'Copy' }}
        </button>
      </article>
    </div>
  </mat-card-content>
</mat-card>
